export default "__VITE_ASSET__DOGWZ80T__"